'use es6';

import { getApiClient } from '../utils/apiClient';
import PortalIdParser from 'PortalIdParser';
const HUBS_BASE = 'hubs/v1';
const PORTAL_ID = PortalIdParser.get();
export const getHub = () => {
  return getApiClient().get(`${HUBS_BASE}/hubs/${PORTAL_ID}`);
};